export default {
	Title: 'Overview',
	TitleProcess: 'Process',
	InstructionsForUse: 'Instructions for use',
	MeInvIntruction: 'MISA Meinvoice user guide',
	VideoIntruction: 'Watch the tutorial video',
	DocsIntruction: 'See the guide article',
	AvaDashboard: 'AI Assistant',
	SearchEmpty: 'No information found matching your search criteria, please try again',
	AvaGreeting: 'Hello! How can AVA help you today?',
	AvaIntroDescription: 'AI tool that helps accelerate and improve your work performance',
	AvaIntroExplore: "Let's explore outstanding AI features with MISA AVA",
	AvaFeatures: {
		SupportSoftware: 'Software usage support',
		CommunityQA: 'Q&A with MISA community on product',
		LegalLookup: 'Legal document lookup',
		QuickReport: 'Quick view of report data',
		TestResult: 'Explain test results',
		CheckVat: 'Check VAT rates for goods and services',
		CostType: 'Automatic cost classification',
		CheckBusiness: 'Check business sectors',
		ReadEmail: 'Translate email content',
		ReadInvoice: 'Read foreign supplier invoices',
		WatchingFilms: 'Watching films'
	},
	AvaFeaturesDesc: {
		TestResult: 'Explain invoice test results, reference related regulations and provide processing guidance',
		CheckVat: 'Check VAT rates for goods and services items on invoices',
		CostType: 'Automatically classify invoices by cost type, check and warn about over-limit invoices',
		CheckBusiness: "Automatically check invoices with goods/services that don't match seller's business sectors",
		ReadEmail: 'Send invoice test result response emails to suppliers in foreign languages',
		ReadInvoice: 'Read specialized invoices from foreign suppliers (Google, Zoom, Meta, Tiktok, etc.)'
	},
	HideLess: 'Show less',
	ShowMore: 'Show More',
	BuyNow: 'Buy now',
	Dashboard: {
		Extend: 'Renew',
		BuyMore: 'Additional purchase',
		LicenseOrderNo: 'Resources for purchasing orders no',
		ApprovedStatus: 'pending',
		InvoiceUncheck: 'Invoice not checked',
		ViewOrder: 'View order',
		TotalInvoiceProcess: 'Total invoices processed',
		BeforeVatAmount: 'Before VAT',
		VatAmount: 'VAT',
		TotalAmount: 'Total amount',
		ViewDetail: 'Read more',
		InvoiceValid: 'Valid invoice',
		InvoiceInValid: 'Invalid invoice',
		SituationReceiveInvoice: 'Timed invoice receipt status',
		InvoiceNo: 'Invoice No.',
		TotalValueAmount: 'Invoice gross amount',
		NotData: 'No data generated',
		LicenseInfo: 'Resource details',
		InvoiceBought: 'Purchased invoices',
		InvoiceUsed: 'Used invoices',
		InvoiceNotUse: 'Unused invoices',
		UseDate: 'Using time to',
		AutoConnectSupplier: 'Auto connect',
		AutoConnectPrefix: 'Automatically ',
		AutoConnectHighlight: 'CONNECT',
		AutoConnectSuffix: ' suppliers',
		MessageConnect:
			'MISA meInvoice has connected with suppliers to automatically retrieve invoices to save more than 80% on data entry and invoice processing time.',
		ConnectNow: 'Connect now',
		CycCodeVND: 'VND',
		Currentcy: 'Currency',
		TooltiptotalAmountWithoutVat: 'Before VAT',
		TooltiptotalVatAmount: 'VAT',
		TooltiptotalAmount: 'Total amount',
		Invoice: 'invoice',
		Million: 'million',
		Thousand: 'thousand',
		Up: 'Increase',
		Down: 'Decrease',
		PercentPeriod: '% compared to the previous period',
		Organizations: 'Other branch - department',
		SuppliersOther: 'Other suppliers',
		NumberInvoice: 'Quantity',
		TotalAmount1: 'Total amount',
		SelectTime: 'Select time',
		FromDate: 'From',
		ToDate: 'To',
		Fee: 'Fees, charges',
		OtherDeductions: 'Other deductions',
		//màn hình quy trình nghiệp vụ
		CreatedEmail: 'Create invoice receipt email',
		UploadInovice: 'Download invoice',
		EmailResponse: 'Receive invoice emails',
		ConnectTaxixaxion: 'Connect with tax authorities',
		ConnectSupplier: 'Supplier connection',
		OrganizationUnit: 'Organizational structure',
		CheckInvoice: 'Processing, checking invoices',
		TitleInvalid: 'Illegal',
		TitleValid: 'Valid',
		SupplierRespone: 'Supplier response',
		ThirdPartyRespone: 'Feedback to Third Parties',
		ExportExcel: 'Export',
		SyncMAKT: `Synchronize with <br /> accounting software`,
		LastTimeGetData: 'Update to {time}',
		TooltipTotalReductionAmount:
			'It is the total amount of goods after deducting discounts (applies to all types of invoices), and also deducts the reduced tax amount in case the invoice is a sales invoice with tax reduction.'
	},
	Intructions: {
		Complete: 'Complete:',
		Title: name => `Hello, ${name}`,
		SubTitle: 'To start using MISA meInvoice - Invoice Processing, please follow these steps',
		TitleStep: 'Get started now',
		NoVideo: 'Video is under construction',
		Step1: {
			Title: 'Overview Introduction',
			SubTitle: 'Overview of the Invoice Processing software',
			Childs1: 'Overview Introduction'
		},
		Step2: {
			Title: 'Create Invoice Receiving Email',
			SubTitle: 'Create an email to receive invoices from the software',
			Childs1: 'Create Invoice Receiving Email'
		},
		Step3: {
			Title: 'Add Invoice to Software',
			SubTitle: 'Methods to add invoices to the software',
			Childs1: 'Upload Invoices',
			Childs2: email => `Send or forward electronic invoices to email ${email}`,
			Childs3: 'Connect to Tax Authority to automatically download invoices',
			Childs4: 'Connect to suppliers to automatically download invoices'
		},
		Step4: {
			Title: 'Process and Validate Invoices',
			SubTitle: 'Explain how to process and validate invoices',
			Childs1: 'Process and Validate Invoices'
		},
		Step5: {
			Title: 'Other Settings',
			SubTitle: 'Set up organizational structure or other settings',
			Childs1: 'Organizational Structure',
			Childs2: 'Optional Settings'
		},
		Step6: {
			Title: 'View Reports',
			SubTitle: "View detailed and summary reports on the unit's invoice usage",
			Childs1: 'Summary of Purchased Goods and Services Invoices',
			Childs2: 'Detailed Purchased Goods and Services Invoices',
			Childs3: 'Risk Invoice Report by Supplier',
			Childs4: 'Invoice Report by Supplier Activity Status',
			Childs5: 'Replacement and Adjustment Invoice Report',
			Childs6: 'Cost Statistics Report by Label',
			Childs7: 'Summary Cost Report'
		},
		Step7: {
			Title: 'Connect to Accounting Software',
			SubTitle: 'Connect to accounting software to download invoices',
			Childs1: 'Connect to AMIS Accounting',
			Childs2: 'Connect to MISA SME',
			Childs3: 'Connect to ASP',
			Childs4: 'Connect to Mimosa Online',
			Childs5: 'Connect to Bamboo Online'
		}
	},
	IntructionsGuide: {
		FilmGuide: 'Software usage guide film',
		TotalFilmSubSystem: total => `${total} films in all subsystems`,
		FilmSeem: (filmSeem, totalFile) => `Watched ${filmSeem}/${totalFile} videos`,
		ChannelsSupport: 'Software support channels',
		AvaChannel: 'Chatting with MISA AVA digital assistant',
		SupportAllTime: 'Answer all product questions, quickly perform functions, and view instant reports.',
		RegisterWithTeacherMISA: 'Register for a course with MISA instructor',
		RegisterNow: 'Register now',
		FilmGuideMISAMeinvoice: 'MISA meInvoice usage guide film',
		HeaderText:
			'Please watch and practice according to the guide films to understand the basic usage of the software',
		PlaceHoder: 'Enter film name to search',
		Unviewed: 'Unviewed',
		Viewed: 'Viewed',
		All: 'All',
		OverView: 'Overview introduction',
		CreateEmailToReceiveInvoices: 'Create email to receive invoices',
		AddInvoicesToTheSoftware: 'Add invoices to the software',
		ProcessCheckTheValidityOfTheInvoice: 'Process and check the validity of the invoice',
		OtherSettings: 'Other settings',
		ViewReport: 'View report',
		ConnectToAccountingSoftware: 'Connect to accounting software',
		ZoomIn: 'Zoom in',
		ZoomOut: 'Zoom out'
	},
	ToolbarGuide: {
		Step1Title: 'Select working unit',
		Step1Content: 'Click to select your working unit.',
		Step2Title: 'Invoice receiving email',
		Step2Content:
			'Send or forward an invoice email to this address so the system automatically processes it. You can click the email to copy it quickly.',
		Step3Title: 'System settings',
		Step3Content:
			'Includes system settings such as: Options, User management, Roles & permissions, Resource management, Access logs,...',
		Step4Title: 'Getting started',
		Step4Content: 'Guide to using MISA meInvoice - Invoice processing.'
	}
};
